var baseUrl = '';
if (process.env.NODE_ENV === 'development') {
  // 本地开发环境
  baseUrl = 'https://admin.liuniu.cn/web/pc/';
  // 可选的开发环境地址
  // baseUrl = 'https://17eu.cn/web/pc/';
} else {
  if (location.hostname.includes('liuniu.cn')) {
    // 线上测试环境（liuniu.cn域名）
    baseUrl = 'https://admin.liuniu.cn/web/pc/';
  } else if (location.hostname.includes('tiyan.17eu.com')) {
    // 灰度测试环境（体验域名）
    baseUrl = 'https://tiyan.17eu.cn/web/pc/';
  } else {
    // 生产环境（其他域名）
    baseUrl = 'https://17eu.cn/web/pc/';
  }
}
export default baseUrl


// WEBPACK FOOTER //
// ./src/assets/js/baseUrl.js